import { render, staticRenderFns } from "./ArticleDetailComment.vue?vue&type=template&id=57437ff2&"
import script from "./ArticleDetailComment.vue?vue&type=script&lang=js&"
export * from "./ArticleDetailComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports